import type { DeliveryMethodTypes } from './types'

export function getDeliveryMethodName(type: number): DeliveryMethodTypes {
  return type === 1 || type === 3 ? 'Email' : 'SMS'
}
